module.exports = __webpack_public_path__ + "img/moreLevels.8442a522.png";